import type { PageCard } from '@/play/pageTypes'
import { SludgeCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'sludge',
  number: 13,
  title: 'Sludge',
  question: 'Does goo that drapes onto the world immediately under the finger feel like direct manipulation?',
  status: 'open',
  accent: '#ffd6e8',
  CardArt: SludgeCardArt,
}
